import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=0d1c0888"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=0d1c0888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports